import React, { useEffect } from 'react';
import { fetchCloudWatchLogs } from "../../utils/api"
import EventDetailsViewer from "./EventDetailsViewer"
import CloudwatchLogDetailsTab from "./CloudwatchLogDetails"
import { Spinner } from "../common/Spinner";
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import { Error } from "../common/Error";

const UsageEventsContentTabs = ({ eventDetail }: any): any => {

  const [cloudWatchLogs, setCloudWatchLogs] = React.useState<string>("");
  const [value, setValue] = React.useState<string>("tab-1");
  const [isLoading, setIsLoading] = React.useState(false as boolean);
  const [errors, setErrors] = React.useState([]);
  const [isDataLoadRequired, setIsDataLoadRequired] = React.useState(false as boolean);

  const handleChange = (event: any, newValue: string) => {
    if (value === newValue) {
      return
    }
    setErrors([]);
    setValue(newValue);
    if (newValue === "tab-2" && isDataLoadRequired) {
      setIsLoading(true);
      getCloudWatchLogs()
    }
  };

  useEffect(
    () => {
      if (eventDetail) {
        setValue("tab-1");
        setIsDataLoadRequired(true);
      }
    },
    [eventDetail],
  );

  const getCloudWatchLogs = () => {
    const usageEvent= JSON.parse(eventDetail);
    fetchCloudWatchLogs(usageEvent.transactionId, usageEvent.timestamp, usageEvent.logGroup)
      .then(response => response.json())
      .then(result => {
        if (result.message) {
          setIsLoading(false);
          setErrors(result.message);
          setIsDataLoadRequired(true);
        } else {
          setCloudWatchLogs(result.response);
          setIsLoading(false);
          setErrors([]);
          setIsDataLoadRequired(false);
        }
      })
      .catch(error => {
        setIsLoading(false);
        setErrors(error.message);
        setIsDataLoadRequired(true);
      });
  }
  return (
    <div className="col-8 p-1">
      <Paper elevation={1} className="h-100 w-100" >
        <TabContext value={value} >
          <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary">
            <Tab label="Usage Events" value="tab-1" />
            <Tab label="CloudWatch Logs" value="tab-2" />
          </Tabs>
          <Divider />
          <TabPanel value="tab-1" id="ueDetails">
            <EventDetailsViewer eventDetail={eventDetail} />
          </TabPanel>
          <TabPanel value="tab-2" id="cloudWatchDetails">
            {cloudWatchLogs && cloudWatchLogs.length > 0
              ? <CloudwatchLogDetailsTab items={cloudWatchLogs} />
              : (!isLoading && errors.length == 0 && <Error message="No data available." />)}
            {errors && <Error message={errors} />}
          </TabPanel>
        </TabContext>
      </Paper>
      {isLoading && <Spinner />}
    </div>
  )
}

export default UsageEventsContentTabs;